import { connect } from 'react-redux';

import {
  GET_PLACE_DETAIL,
  CLEAR_PLACE_DETAIL,
  UPDATE_PLACE_SERVICE_FEE,
  ADD_PLACE_OTHER_FEE,
  UPDATE_PLACE_OTHER_FEE,
  DELETE_PLACE_OTHER_FEE,
} from 'store/place/actionTypes';

import VatService from './VatService';

const mapStateToProps = (state) => ({
  isLoadingGetPlaceDetail: state.Place.isLoadingGetPlaceDetail,
  isLoadingUpdatePlaceServiceFee: state.Place.isLoadingUpdatePlaceServiceFee,
  isLoadingAddPlaceOtherFee: state.Place.isLoadingAddPlaceOtherFee,
  isLoadingUpdatePlaceOtherFee: state.Place.isLoadingUpdatePlaceOtherFee,
  isLoadingDeletePlaceOtherFee: state.Place.isLoadingDeletePlaceOtherFee,
  placeDetail: state.Place.placeDetail,
});

const mapDispatchToProps = {
  actionGetPlaceDetail: (payload) => ({
    type: GET_PLACE_DETAIL,
    payload,
  }),

  actionClearPlaceDetail: () => ({
    type: CLEAR_PLACE_DETAIL,
  }),

  actionUpdatePlaceServiceFee: (payload) => ({
    type: UPDATE_PLACE_SERVICE_FEE,
    payload,
  }),

  actionAddPlaceOtherFee: (payload) => ({
    type: ADD_PLACE_OTHER_FEE,
    payload,
  }),

  actionUpdatePlaceOtherFee: (payload) => ({
    type: UPDATE_PLACE_OTHER_FEE,
    payload,
  }),

  actionDeletePlaceOtherFee: (payload) => ({
    type: DELETE_PLACE_OTHER_FEE,
    payload,
  }),
};

export default connect(mapStateToProps, mapDispatchToProps)(VatService);
